var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"edFlow",staticClass:"ed-flow"},[_vm._l((_vm.dateArray),function(date,index){return [_c('ed-flow-item',{key:index,attrs:{"end":_vm.end || _vm.nowDate,"flow-item":date,"notDate":_vm.getNotDate,"sort":index+1,"start":_vm.start,"stopDate":_vm.getStopDate,"total":_vm.dateArray.length,"width":_vm.itemWidth}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }